var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", { attrs: { title: _vm.title, items: _vm.items } }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Order Name",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "order-name", trim: "" },
                                model: {
                                  value: _vm.search_condition.orderName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "orderName",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.orderName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Order No.",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-number"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "order-number", trim: "" },
                                model: {
                                  value: _vm.search_condition.orderNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "orderNumber",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.orderNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Device Model",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "model-name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "model-name", trim: "" },
                                model: {
                                  value: _vm.search_condition.deviceModelName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "deviceModelName",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.deviceModelName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Production Time",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "create-time"
                              }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  format: "MM/DD/YYYY",
                                  range: "",
                                  "append-to-body": "",
                                  lang: "en",
                                  placeholder: "Select date"
                                },
                                model: {
                                  value: _vm.createTime,
                                  callback: function($$v) {
                                    _vm.createTime = $$v
                                  },
                                  expression: "createTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Affiliated Customer",
                                "label-cols-lg": "4",
                                "label-align-lg": "right",
                                "label-for": "customer"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "customer",
                                  options: _vm.types.allSupplier,
                                  "value-field": "id",
                                  "text-field": "brandName"
                                },
                                model: {
                                  value: _vm.search_condition.supplierId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "supplierId",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.supplierId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Status",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-status"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "order-status",
                                  options: _vm.types.statuss
                                },
                                model: {
                                  value: _vm.search_condition.status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.search()
                                }
                              }
                            },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "deviceProductionOrders::Create",
                          expression: "'deviceProductionOrders::Create'"
                        }
                      ],
                      attrs: { variant: "primary" },
                      on: { click: _vm.gotoAdd }
                    },
                    [_vm._v("Create")]
                  ),
                  _c(
                    "div",
                    { staticClass: "table-responsive mb-0" },
                    [
                      _c("b-table", {
                        ref: "table",
                        attrs: {
                          id: "device-table",
                          "head-variant": "light",
                          "show-empty": "",
                          "empty-text": "no records",
                          busy: _vm.isBusy,
                          striped: true,
                          items: _vm.provider,
                          fields: _vm.fields,
                          "per-page": _vm.search_condition.pageSize,
                          "current-page": _vm.search_condition.pageNum,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          filter: _vm.filter,
                          "filter-includedfields": _vm.filterOn
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _c("strong", [_vm._v("Loading...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.index +
                                        (_vm.search_condition.pageNum - 1) *
                                          _vm.search_condition.pageSize +
                                        1
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value:
                                              "deviceProductionOrders::Details",
                                            expression:
                                              "'deviceProductionOrders::Details'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.show(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" Details ")]
                                    ),
                                    row.item.isDistribution == 1 &&
                                    row.item.status == 1 &&
                                    row.item.isCancel == 1
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value:
                                                  "deviceProductionOrders::Allocation",
                                                expression:
                                                  "'deviceProductionOrders::Allocation'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "info"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.assigningCustomer(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Allocation ")]
                                        )
                                      : _vm._e(),
                                    row.item.status == 0 &&
                                    row.item.isCancel == 1
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value:
                                                  "deviceProductionOrders::Cancel",
                                                expression:
                                                  "'deviceProductionOrders::Cancel'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.cancel(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Cancel ")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.has_data
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dataTables_paginate paging_simple_numbers float-right"
                              },
                              [
                                _vm.rows != 0
                                  ? _c(
                                      "ul",
                                      { staticClass: "pagination mb-0" },
                                      [
                                        _c("b-pagination", {
                                          ref: "page",
                                          attrs: {
                                            "per-page": 10,
                                            "total-rows": _vm.rows,
                                            "aria-controls": "table"
                                          },
                                          model: {
                                            value: _vm.search_condition.pageNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.search_condition,
                                                "pageNum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "search_condition.pageNum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modal",
                  attrs: { title: "Assigning Customer", "hide-footer": "" },
                  on: { hidden: _vm.resetAssigningCustomerShow },
                  model: {
                    value: _vm.assigningCustomerShow,
                    callback: function($$v) {
                      _vm.assigningCustomerShow = $$v
                    },
                    expression: "assigningCustomerShow"
                  }
                },
                [
                  _c(
                    "form",
                    {
                      ref: "form",
                      on: {
                        submit: _vm.onSubmitAssigningCustomerShow,
                        reset: _vm.onResetAssigningCustomerShow
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Affiliated Customer:",
                            "label-cols-lg": "4",
                            "label-align-lg": "right",
                            "label-for": "mode"
                          }
                        },
                        [
                          _c("multiselect", {
                            attrs: {
                              options: _vm.types.allSupplier,
                              "track-by": "id",
                              label: "brandName",
                              placeholder: "Please select"
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeSupplierId(_vm.supplier)
                              }
                            },
                            model: {
                              value: _vm.supplier,
                              callback: function($$v) {
                                _vm.supplier = $$v
                              },
                              expression: "supplier"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Remarks:",
                            "label-cols-lg": "4",
                            "label-align-lg": "right",
                            "label-for": "remark"
                          }
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "remark",
                              placeholder: "Enter Notes",
                              rows: "3",
                              "max-rows": "6"
                            },
                            model: {
                              value: _vm.typeform.distributionRemarks,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.typeform,
                                  "distributionRemarks",
                                  $$v
                                )
                              },
                              expression: "typeform.distributionRemarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        { attrs: { "label-cols-lg": "2" } },
                        [
                          _c(
                            "b-button",
                            { attrs: { type: "submit", variant: "primary" } },
                            [_vm._v("Confirm")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "m-l-5 ml-1",
                              attrs: { type: "reset" }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }